<p-card class="p-card container" [class.proposal-section--valid]="isCompleted">
  <h3 class="margin--top-none" i18n>Notes</h3>
  <p i18n>Ces notes pourront être consultées par le tarificateur.</p>

  <textarea
    placeholder="Aa..."
    [formControl]="form"
    [maxlength]="5000"
    rows="6"
    class="w-full"
    pInputTextarea></textarea>
</p-card>
